import { render } from "./createstocktransfer.vue?vue&type=template&id=78f90054&scoped=true"
import script from "./createstocktransfer.vue?vue&type=script&lang=js"
export * from "./createstocktransfer.vue?vue&type=script&lang=js"

import "./createstocktransfer.vue?vue&type=style&index=0&id=78f90054&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f90054"]])

export default __exports__